import React from 'react';
import '../less/acceptingPayments.less';
import hero_img from '../img/hero_img.png';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import Advantages from '../../../../../auxiliary-components/shared/AdvantagesBlock';
import Tabs from '../../../../../auxiliary-components/shared/Tabs';
import Tariffs from '../../../../../auxiliary-components/shared/TariffsBlock';
import AdditionalProduct from '../../../../../auxiliary-components/shared/AdditionalProductBlock';
import tariffsData01 from '../enums/tariffs_01_data.json';
import tariffsData02 from '../enums/tariffs_02_data.json';
import additionalCards01 from '../enums/additional_cards_01_data.json';
import additionalCards02Data from '../enums/additional_cards_02_data.json';
import hero_data from '../enums/hero_data.json';
import advantages_img_1 from '../img/advantages_img_1.png';
import advantages_img_2 from '../img/advantages_img_2.png';
import advantages_img_3 from '../img/advantages_img_3.png';
import advantages_img_4 from '../img/advantages_img_4.png';
import advantagesItemsData from '../enums/advantages_items.json';
import BusinessOrder from '../../../../BusinessOrder';
import DOMPurify from 'utils/sanitize';

const imagesMap = {
  advantages_img_1,
  advantages_img_2,
  advantages_img_3,
  advantages_img_4
};

export default function template() {
    const tabs = [{tab: 'recipient', title: 'ACCEPTING_PAYMENTS_NEW_TABS_TITLE_01'},
          {tab: 'payer', title: 'ACCEPTING_PAYMENTS_NEW_TABS_TITLE_02'}];

    const handlersMap = {
      toggleModal: () => this.toggleModal()
    };

    const heroData = {
      ...hero_data,
      link: {
        ...hero_data.link,
        onClick: handlersMap[hero_data.link.onClick],
      },
    };

    const advantagesItems = advantagesItemsData.map(item => ({
      ...item,
      img: imagesMap[item.img]
    }));

    const additionalCards02 = additionalCards02Data.map(item => ({
      ...item,
      onClick: handlersMap[item.onClick]
    }));

    return (
      <div className="accepting-payments-module">
        <Hero
          data={heroData}
          img={hero_img}
        />
        <div className="content">
          <Advantages
            title={'ACCEPTING_PAYMENTS_NEW_ADVANTAGES_TITLE'}
            items={advantagesItems}
          />
          <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab} title={'ACCEPTING_PAYMENTS_NEW_TABS_TITLE'}>
            <div className="tariffs-block">
              <Tariffs 
                items={tariffsData01}
                alignItems="start"
              />
              <div className="container">
                <div className="tariffs-block__text">
                  <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('ACCEPTING_PAYMENTS_NEW_TARIFFS_01_TEXT_01'))}}></p>
                  <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('ACCEPTING_PAYMENTS_NEW_TARIFFS_01_TEXT_02'))}}></p>
                </div>
              </div>
            </div>
            <div className="tariffs-block">
              <Tariffs
                items={tariffsData02}
                alignItems="start"
              />
              <div className="container">
                <div className="tariffs-block__text">
                  <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('ACCEPTING_PAYMENTS_NEW_TARIFFS_02_TEXT_01'))}}></p>
                  <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('ACCEPTING_PAYMENTS_NEW_TARIFFS_02_TEXT_02'))}}></p>
                </div>
              </div>
            </div>
          </Tabs>
          <AdditionalProduct
            items={additionalCards01}
            title={'ACCEPTING_PAYMENTS_NEW_ADDITIONAL_PRODUCT_01_TITLE'}
          />
          <AdditionalProduct
            items={additionalCards02}
          />
        </div>
        {this.state.showModal && <BusinessOrder attribute="accepting-payments" closeModal={this.toggleModal} />}
      </div>
    );
}
